import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ListItem1 from 'Components/ComponentLibrary/Components/ListItems/ListItem1';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import FinancialInstitutionImagePicker
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/FinancialInstitutionImagePicker';

import { currency } from 'Helpers/Formats';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import useLineItem from './useLineItem';
import ManageLineItemModal from './ManageLineItemModal';


const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
  },
  modalRoot: {},
  listItemRoot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 1),
    borderRadius: theme.radius.md,
  },
  accountDetail: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: 0,
    padding: theme.spacing(1),
  },
  accountTypeRoot: {
    paddingRight: theme.spacing(1),
  },
});

const LineItem = ({
  className,
  classes,
  lineItemResource,
}) => {
  const {
    isModalOpen,
    handleCloseModal,
    handleClickItem,
  } = useLineItem(lineItemResource);
  const accountType = lineItemResource.attr('type');
  const accountBalance = currency(lineItemResource.attr('balance'), true);

  return (
    <React.Fragment>
      <ListItem1
        className={classNames(classes.root, className)}
        button
        component={Paper}
        variant={'subtle'}
        elevation={1}
        onClick={handleClickItem}
        classes={{
          root: classes.listItemRoot,
        }}
        test={'balance-sheet-section-account'}
      >
        <FinancialInstitutionImagePicker
          resource={lineItemResource}
          width={'125'}
          height={'auto'}
        />
        <div className={classes.accountDetail}>
          {/* -------- Account label (type) -------- */}
          <Typography
            className={classes.accountTypeRoot}
            color={'primary'}
            variant={'h6'}
            weight={'medium'}
            noWrap
          >
            {accountType}
          </Typography>

          {/* -------- Account Balance -------- */}
          <Typography
            color={'primary'}
            variant={'h6'}
            weight={'medium'}
          >
            {accountBalance}
          </Typography>

          <MoreVertIcon color={'primary'} />
        </div>
      </ListItem1>
      <ManageLineItemModal
        className={classes.modalRoot}
        lineItemResource={lineItemResource}
        isModalOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </React.Fragment>
  );
};

LineItem.defaultProps = {
  className: '',
};

LineItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(LineItem);
